import { useAuth } from '@/lib/auth/auth';
import { useMutation } from '@tanstack/react-query';

type UploadAvatarArgs = {
  uri: string;
  mimeType?: string | null;
  fileName?: string | null;
};

type UploadAvatarResponse = {
  url: string;
};

export function useAvatarUpload() {
  const requestRaw = useAuth((state) => state.requestRaw);

  return useMutation({
    mutationFn: async ({ uri, mimeType, fileName }: UploadAvatarArgs) => {
      const formData = new FormData();
      formData.append('avatar', {
        uri,
        type: mimeType ?? 'image/jpeg',
        name: fileName ?? 'avatar.jpg',
      } as any);

      const response = await requestRaw('/uploads/avatar', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Upload failed');
      }

      return (await response.json()) as UploadAvatarResponse;
    },
  });
}
